<template>
  <div class="applicationCredit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'accountType'">
              {{ accountsTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'requestStatus'">
              {{ requestStatusData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.type === 'seq'">{{ scope.row['rowNo'] }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/applicationCredit.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import status from '@/common/js/status';
  import { filterEmpty } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'applicationCreditList',
    data() {
      return {
        load: false,
        img: './static/img/tips.png',
        query: {
          controlAreaCode: null,
          partnerName: null,
          enterpriseType: null,
          requestStatus: null,
          requestDateStart: null,
          requestDateEnd: null,
          creditType: null,
          accountType: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        enterprisePropertyList: [], //企业类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        creditTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
        accountsTypeData: [],
        creditTypeData: [],
        requestStatusData: [],
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            type: 'seq',
            title: 'table.index',
            visible: true,
            width: '60',
          },
          {
            field: 'creditRequestNo',
            title: 'applicationCredit.table.creditRequestNo',
            //sortable: true,
            width: '160',
            visible: true,
          },
          {
            field: 'controlAreaName',
            title: 'applicationCredit.table.departmentCode',
            visible: true,
          },
          { field: 'requestDate', title: 'applicationCredit.table.requestDate', visible: true },
          {
            field: 'requestPersonName',
            title: 'applicationCredit.table.requestPerson',
            visible: true,
          },
          { field: 'partnerName', title: 'applicationCredit.table.partnerName', visible: true },
          { field: 'creditCode', title: 'applicationCredit.table.creditCode', visible: true },
          { field: 'accountType', title: 'applicationCredit.table.accountType', visible: true },
          { field: 'creditType', title: 'applicationCredit.table.creditType', visible: true },
          { field: 'requestAmount', title: 'applicationCredit.table.requestAmount', visible: true },
          {
            field: 'basicCurrencyType',
            title: 'applicationCredit.table.basicCurrencyType',
            visible: true,
          },
          { field: 'requestStatus', title: 'applicationCredit.table.requestStatus', visible: true },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'controlAreaCode',
            name: this.$t('applicationCredit.search.businessDepartment'),
            placeholder: this.$t('applicationCredit.search.businessDepartmentPlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_TREE,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
              currentStatus: '0',
            },
            clearable: false,
            normalizerFlag: true,
          },
          {
            prop: 'partnerName',
            name: this.$t('applicationCredit.search.partnerName'),
            type: 'input',
            placeholder: this.$t('applicationCredit.search.partnerNamePlaceholder'),
          },
          {
            prop: 'enterpriseType',
            name: this.$t('applicationCredit.search.enterpriseProperty'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('applicationCredit.search.enterprisePropertyPlaceholder'),
            options: this.enterprisePropertyList,
          },
          {
            prop: 'requestStatus',
            name: this.$t('applicationCredit.search.requestStatus'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('applicationCredit.search.requestStatusPlaceholder'),
            options: this.requestStatusList,
          },
          {
            prop: 'requestDateStart',
            name: this.$t('applicationCredit.search.requestDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('applicationCredit.search.requestDateStartPlaceholder'),
          },
          {
            prop: 'requestDateEnd',
            name: this.$t('applicationCredit.search.requestDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('applicationCredit.search.requestDateEndPlaceholder'),
          },
          {
            prop: 'creditType',
            name: this.$t('applicationCredit.search.creditType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('applicationCredit.search.creditTypePlaceholder'),
            options: this.creditTypeList,
          },
          {
            prop: 'accountType',
            name: this.$t('applicationCredit.search.accountsType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('applicationCredit.search.accountsTypePlaceholder'),
            options: this.accountsTypeList,
          },
        ];
      },
      ...mapState({
        applicationCreditInfo: (state) => state.applicationCreditInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getDepartmentList();
      this.getDic();
      this.getData();
      this.getButtonList();
    },
    methods: {
      //事业部门
      getDepartmentList() {
        // dictType:"enterprise_type",sonar重复定义零时注释
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: this.userInfo.userInfo.tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.businessDepartmentList = res.data.data;
            }
          });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //企业类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'enterprise_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterprisePropertyList = res.data.data;
            }
          });
        //申请单状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'request_status', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.requestStatusList = res.data.data;
              for (var item of res.data.data) {
                this.requestStatusData[item['value']] = item['label'];
              }
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              for (var item of res.data.data) {
                this.creditTypeData[item['value']] = item['label'];
              }
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'account_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.accountsTypeList = res.data.data;
              for (var item of res.data.data) {
                this.accountsTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.APPLICATION_CREDIT_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list.map((item, index) => {
              return {
                ...item,
                rowNo: index + 1,
              };
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },

      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'export') {
          //导出
          this.export();
        } else if (type === 'edit') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.noSelectDel'),
              type: 'error',
            });
          } else if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.onlyCanSelectNoEdit'),
              type: 'error',
            });
          } else if (
            this.multipleSelection.length === 1 &&
            !(
              this.multipleSelection[0].requestStatus === status.ZT06 ||
              this.multipleSelection[0].requestStatus === status.ZT05
            )
          ) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.typeSelectEdit'),
              type: 'error',
            });
          } else {
            let path = {
              path: '/credit/applicationCreditEdit',
              name: 'applicationCreditEdit',
              meta: {
                keepAlive: true,
              },
              query: {
                creditRequestNo: this.multipleSelection[0].creditRequestNo,
                id: this.multipleSelection[0].id,
                canEdit: '1',
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
      },
      //新增
      add() {
        let path = {
          path: '/credit/applicationAdd',
          name: 'applicationCreditAdd',
          meta: {
            keepAlive: false,
          },
          query: { canEdit: '1' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除
      del() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('applicationCredit.msg.noSelectDel'),
            type: 'error',
          });
        } else {
          // 状态：只有已保存和已驳回状态可以删除
          const notStatus = ['ZT05', 'ZT06'];
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (!notStatus.includes(this.multipleSelection[i].requestStatus)) {
              this.$message({
                showClose: true,
                message: this.$t('applicationCredit.msg.typeSelectDel'),
                type: 'error',
              });
              return;
            }
          }
          this.$confirmAction()
            .then(() => {
              let ids = [];
              this.multipleSelection.map((item) => {
                ids.push(item.id);
              });
              this.$axios.post(API.DELETE_APPLICATION_CREDIT_API, { ids }).then((res) => {
                if (0 == res.data.code) {
                  //如果操作成功，直接返回列表
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  //如果有错误返回，提示信息
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.$refs.siruiSearch.query;
        const params = filterEmpty(query);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios.post(API.EXPORT_APPLICATION_CREDIT_API, filterEmpty(params)).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/credit/applicationDetail',
          name: 'applicationCreditDetail',
          meta: {
            keepAlive: false,
          },
          query: { creditRequestNo: value.row.creditRequestNo, id: value.row.id, canEdit: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
